export const SET_NAME: 'SET_NAME' = 'SET_NAME';
export const SET_EMAIL: 'SET_EMAIL' = 'SET_EMAIL';
export const SET_LOGIN: 'SET_LOGIN' = 'SET_LOGIN';
export const SET_PASSWORD: 'SET_PASSWORD' = 'SET_PASSWORD';
export const SET_RESTORE_EMAIL: 'SET_RESTORE_EMAIL' = 'SET_RESTORE_EMAIL';
export const REGISTER_USER_REQUEST: 'REGISTER_USER_REQUEST' = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS' = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED: 'REGISTER_USER_FAILED' = 'REGISTER_USER_FAILED';
export const LOGIN_USER_REQUEST: 'LOGIN_USER_REQUEST' = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS' = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED: 'LOGIN_USER_FAILED' = 'LOGIN_USER_FAILED';
export const UPDATE_USER_DATA_REQUEST: 'UPDATE_USER_DATA_REQUEST' = 'UPDATE_USER_DATA_REQUEST';
export const UPDATE_USER_DATA_SUCCESS: 'UPDATE_USER_DATA_SUCCESS' = 'UPDATE_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_FAILED: 'UPDATE_USER_DATA_FAILED' = 'UPDATE_USER_DATA_FAILED';
export const CANCEL_UPDATE_USER_DATA: 'CANCEL_UPDATE_USER_DATA' = 'CANCEL_UPDATE_USER_DATA';
export const RESTORE_PASSWORD_REQUEST: 'RESTORE_PASSWORD_REQUEST' = 'RESTORE_PASSWORD_REQUEST';
export const RESTORE_PASSWORD_SUCCESS: 'RESTORE_PASSWORD_SUCCESS' = 'RESTORE_PASSWORD_SUCCESS';
export const RESTORE_PASSWORD_FAILED: 'RESTORE_PASSWORD_FAILED' = 'RESTORE_PASSWORD_FAILED';
export const GET_NEW_PASSWORD_REQUEST: 'GET_NEW_PASSWORD_REQUEST' = 'GET_NEW_PASSWORD_REQUEST';
export const GET_NEW_PASSWORD_SUCCESS: 'GET_NEW_PASSWORD_SUCCESS' = 'GET_NEW_PASSWORD_SUCCESS';
export const GET_NEW_PASSWORD_FAILED: 'GET_NEW_PASSWORD_FAILED' = 'GET_NEW_PASSWORD_FAILED';
export const SET_NEW_PASSWORD: 'SET_NEW_PASSWORD' = 'SET_NEW_PASSWORD';
export const SET_RESTORE_CODE: 'SET_RESTORE_CODE' = 'SET_RESTORE_CODE';
export const REFRESH_TOKEN_REQUEST: 'REFRESH_TOKEN_REQUEST' = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS' = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILED: 'REFRESH_TOKEN_FAILED' = 'REFRESH_TOKEN_FAILED';
export const LOGOUT_USER_REQUEST: 'LOGOUT_USER_REQUEST' = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS: 'LOGOUT_USER_SUCCESS' = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILED: 'LOGOUT_USER_FAILED' = 'LOGOUT_USER_FAILED';